import React, { useRef, useState } from "react";

export default function Note({ authorFirstName, authorLastName, authorFullName, date, note, type, userImgUrl, menu }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Derive initials: prefer explicit first/last, fall back to splitting fullName
  const initials = authorFirstName
    ? (authorFirstName.charAt(0) + (authorLastName?.charAt(0) || "")).toUpperCase()
    : (authorFullName !== "Unknown" ? authorFullName : "-")
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((n) => n[0])
        .join("")
        .toUpperCase();

  const handleMenuToggle = (e) => {
    e.stopPropagation();
    setMenuOpen((v) => !v);
  };

  // Close menu when clicking outside
  React.useEffect(() => {
    if (!menuOpen) return;
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [menuOpen]);

  return (
    <div className="note-row">
      <div className="note-header">
        <div className="note-badge">
          {userImgUrl ? <img src={userImgUrl} alt="avatar" className="note-badge-img" /> : initials}
        </div>
        <div className="note-meta">
          <div className="note-author-info">
            <span className="note-author">{authorFullName}</span>
            <span className="note-date">{date}</span>
          </div>
          <span
            className={`note-type${type === "Conclusion" ? " note-type-conclusion" : type === "Draft Conclusion" ? " note-type-draft" : ""}`}
          >
            {type || "General"}
          </span>
        </div>
        {menu && menu.length > 0 && (
          <div className="note-menu" ref={menuRef}>
            <button className="note-menu-btn" onClick={handleMenuToggle} title="More">
              <span className="material-icons">more_horiz</span>
            </button>
            {menuOpen && (
              <div className="note-menu-dropdown">
                {menu.map((item, i) => (
                  <button
                    key={i}
                    className="note-menu-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      setMenuOpen(false);
                      item.onClick();
                    }}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
      <div className="note-content">{note}</div>
    </div>
  );
}
